import asMethods from './As/Config';

export default {
  ...asMethods,
};
